import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.node,
  wrapperClassNames: PropTypes.string,
  contentPaneClassNames: PropTypes.string,
};

const Wrapper = ({ children, wrapperClassNames, contentPaneClassNames }) => {
  const wrapperClasses = classNames({
    'shutterbug-split-layout': true,
    [wrapperClassNames]: !!wrapperClassNames,
  });

  const contentPaneClasses = classNames({
    'split-layout-left-right-pane split-layout-right-content-pane': true,
    [contentPaneClassNames]: !!contentPaneClassNames,
  });

  return (
    <div className={wrapperClasses}>
      <div className="split-layout-left-right-pane split-layout-background-picture-full-screen">
        <div className="split-layout-hero">
          <p className="split-layout-hero-eyebrow">Photo sharing by Waldo</p>
          <h3 className="split-layout-hero-title">Simpler. Safer. Smarter.</h3>
        </div>
      </div>
      <div className={contentPaneClasses}>{children}</div>
    </div>
  );
};

Wrapper.propTypes = propTypes;

export default Wrapper;
